import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import '@fortawesome/fontawesome-free/css/all.css'
import Snotify, {SnotifyPosition} from 'vue-snotify'
import './assets/snotify-material.css'
import VueI18n from 'vue-i18n'
import en from './localization/en.js'
import ru from './localization/ru.js'
import ka from './localization/ka.js'
import '../../styles/scss/main.scss'
import {getBrowserLocales} from '@/helpers/browser'
import _ from 'lodash'

Vue.use(VueI18n)

let browserLanguage = _.get(getBrowserLocales({languageCodeOnly: true}), 0, 'en')

const snotifyOptions = {
    toast: {
        position: SnotifyPosition.rightTop,
        timeout: 10000
    }
}

Vue.use(Snotify, snotifyOptions)

Vue.config.productionTip = false

async function init() {
    //await store.dispatch('auth/getUserInfo')

    new Vue({
        vuetify: vuetify,
        router: router,
        i18n: new VueI18n({
            fallbackLocale: 'en',
            locale: browserLanguage,
            messages: {
                ru,
                en,
                ka
            }
        }),
        render: h => h(App)
    }).$mount('#app')

    //store.$app = app
}

init()
